
const Tooltip = (props) => {
  return (
    <div className="tooltip">
      <div className={`${props.position ? 'bottom' : 'top'}`}>
        <i className="nexi-icon-info" />
        <div className="content">
          <p className="text">{props.message}</p>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
